import React, { useEffect, useState } from "react";
import { MdMenu, MdNotifications } from "react-icons/md";
import axiosInstance from "../Api/config";
import { useNavigate, useLocation } from "react-router-dom";

const Header = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const [notifications, setNotifications] = useState([]);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // 🔥 Load only pending
  const loadNotifications = async () => {
    try {
      const res = await axiosInstance.get("/leave/all?status=Pending");
      setNotifications(res.data.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadNotifications();

    const interval = setInterval(loadNotifications, 10000);
    return () => clearInterval(interval);
  }, []);

  // 🔥 CLOSE dropdown on route change
  useEffect(() => {
    setShow(false);
  }, [location.pathname]);

  // 🔥 HANDLE CLICK
const handleNotificationClick = async () => {
  try {
    await axiosInstance.put("/leave/mark-read");
  } catch (err) {
    console.log(err);
  }

  setNotifications([]);
  setShow(false);
  navigate("/leave");
};

  return (
    <header className="w-full fixed top-0 left-0 bg-white z-10 shadow">
      <div className="flex items-center justify-between px-4 py-2">

        {/* LEFT */}
        <button
          className="lg:hidden text-2xl"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <MdMenu />
        </button>

        {/* RIGHT */}
        <div className="flex items-center gap-4 ml-auto">

          <div className="relative">
            <button
              onClick={() => setShow(!show)}
              className="text-2xl relative"
            >
              <MdNotifications />

              {/* 🔴 badge */}
              {notifications.length > 0 && (
                <span className="absolute -top-1 -right-2 bg-red-500 text-white text-xs px-1.5 rounded-full">
                  {notifications.length}
                </span>
              )}
            </button>

            {/* 🔽 Dropdown */}
            {show && (
              <div className="absolute right-0 mt-3 w-72 bg-white shadow-lg rounded-lg p-2 max-h-80 overflow-y-auto border">

                <h3 className="text-sm font-semibold px-2 mb-2">
                  Notifications
                </h3>

                {notifications.length === 0 ? (
                  <p className="text-sm text-gray-500 px-2">
                    No notifications
                  </p>
                ) : (
                  notifications.map((item) => (
                    <div
                      key={item._id}
                      onClick={handleNotificationClick}
                      className="border-b p-2 text-sm hover:bg-gray-100 rounded cursor-pointer"
                    >
                      <p className="font-semibold">
                        {item.user?.name}
                      </p>
                      <p className="text-gray-500 text-xs">
                        Requested leave
                      </p>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;